// extracted by mini-css-extract-plugin
export default {"itemsPerPage":"DashboardItemsPerPage_itemsPerPage__Cs3BJ","selectLabel":"DashboardItemsPerPage_selectLabel__-v9r3"};